import { render } from "./App.vue?vue&type=template&id=53c5b63e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=53c5b63e&lang=less"

import exportComponent from "e:\\AiGreate\\tmp\\vertex\\webui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__